import { Skeleton } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

type Props = {
  nRows?: number;
}

const SkeletonLoadingTable = ({nRows = 10}: Props) => {
  const skeletonRows = Array.from({ length: nRows }, (_, index) => (
    <TableRow key={index}>
      <TableCell>
        <Skeleton variant="text" />
      </TableCell>
    </TableRow>
  ));

  return (
    <TableContainer>
      <Table>
        <TableBody>{skeletonRows}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default SkeletonLoadingTable;
